<script setup>
defineProps({
  label: {
    type: String,
    required: true,
  },
  active: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['click']);
</script>

<template>
  <button
    type="button"
    class="flex h-8 min-h-8 w-full items-center rounded-none px-2 text-start text-sm font-medium leading-5 transition-colors duration-100 ease-out"
    :class="
      active
        ? 'font-medium text-n-blue-11'
        : 'text-n-slate-11 hover:bg-n-alpha-2 hover:text-n-slate-12'
    "
    @click="emit('click', $event)"
  >
    {{ label }}
  </button>
</template>
